export const InventoryFormAction = Object.freeze({
	Hide: 1,
	Show: 2,
	Set: 3,
	ShowBubble: 4,
	HideBubble: 5,
	ShowHelp: 6,
	HideHelp: 7,
	QuestionHelp: 8,
});
